// Reducer for homepage actions

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultAudienceAcquisitionState = {
  byId: {}
}

export const DefaultAudienceAcquisitionDetailsState = {
  ...DefaultState
}

const audienceAcquisitionDetails = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultAudienceAcquisitionDetailsState,
  actionRequest: ActionTypes.REQUEST_AUDIENCE_ACQUISITION,
  actionFailure: ActionTypes.REQUEST_AUDIENCE_ACQUISITION_FAILURE,
  actionReceive: ActionTypes.RECEIVE_AUDIENCE_ACQUISITION,
  actionInvalidate: ActionTypes.INVALIDATE_AUDIENCE_ACQUISITION
})

const audienceAcquisitionById = (state = {}, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_AUDIENCE_ACQUISITION:
    case ActionTypes.RECEIVE_AUDIENCE_ACQUISITION:
    case ActionTypes.REQUEST_AUDIENCE_ACQUISITION_FAILURE:
    case ActionTypes.INVALIDATE_AUDIENCE_ACQUISITION:
      return {
        ...state,
        audienceAcquisition: audienceAcquisitionDetails(state.list, action)
      }
  }
}
export const audienceAcquisition = (state = DefaultAudienceAcquisitionState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_AUDIENCE_ACQUISITION:
    case ActionTypes.RECEIVE_AUDIENCE_ACQUISITION:
    case ActionTypes.REQUEST_AUDIENCE_ACQUISITION_FAILURE:
    case ActionTypes.INVALIDATE_AUDIENCE_ACQUISITION:
      if (action.networkEntityId) {
        return {
          ...state,
          byId: {
            ...state.byId,
            [action.networkEntityId]: audienceAcquisitionById(state.byId[action.networkEntityId], action)
          }
        }
      } else {
        console.warn('Topic action fired without a topic id:', action)
        return state
      }
    default:
      return state
    }
}